import { render, staticRenderFns } from "./template.html?vue&type=template&id=40535678&scoped=true&external"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=40535678&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40535678",
  null
  
)

export default component.exports